module.exports = __webpack_public_path__ + "img/chevy03.b6ca441a.png";